// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navik-header {
  z-index: 999 !important;
  background-color: wgite;
}
.navik-header.dark {
  background-color: var(--secondary-color-1);
}
.navik-header.dark .navik-menu ul li > a {
  color: white !important;
}
.navik-header.dark .navik-header-container .mobile-signin-link {
  color: white;
}
.navik-header.dark .navik-header-container .burger-menu > div {
  background-color: white;
}
.navik-header .navik-header-container {
  padding: 0 80px;
  height: 80px !important;
}
.navik-header .navik-header-container .logo img {
  height: 20px;
}
.navik-header .navik-header-container .mobile-signin-link {
  font-size: 10px;
  color: var(--primary-color-1);
  font-weight: 700;
  font-family: "Proxima Nova", sans-serif;
  margin: 0;
}
.navik-header .navik-header-container .mobile-nav {
  display: none;
}
.navik-header .navik-header-container .burger-menu {
  position: static;
  align-items: center;
}
.navik-header .navik-header-container .burger-menu.menu-open > div.line-menu.last-line {
  align-self: flex-end;
}
.navik-header .navik-header-container .burger-menu.menu-open > div.line-menu.first-line {
  align-self: normal;
}
.navik-header .navik-header-container .burger-menu > div {
  background-color: var(--secondary-color-1);
}
.navik-header .navik-header-container .burger-menu > div.line-menu {
  height: 2px;
}
.navik-header .navik-header-container .burger-menu > div.line-menu.last-line {
  align-self: center;
}
.navik-header .navik-menu,
.navik-header .navik-menu > ul,
.navik-header .navik-menu > ul li a {
  height: 80px;
}
.navik-header .navik-menu > ul {
  display: flex !important;
  align-items: center;
}
.navik-header .navik-menu ul li > a {
  text-transform: none;
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700 !important;
  font-size: 14px !important;
  color: var(--secondary-color-1) !important;
  font-style: normal;
  line-height: 80px !important;
  padding: 0 15px !important;
  transition: 0.2s ease-in;
  height: 80px;
  white-space: nowrap;
}
.navik-header .navik-menu ul li > a:hover, .navik-header .navik-menu ul li > a.active {
  color: #FAC91F !important;
}
.navik-header .navik-menu ul li > a.darkmode:hover, .navik-header .navik-menu ul li > a.darkmode.active {
  color: var(--secondary-color-1) !important;
}
.navik-header .navik-menu > ul > li.sign-in > button {
  margin-left: 20px;
}
.navik-header button.darkmode {
  background: var(--secondary-color-1) !important;
}
.navik-header button.darkmode:hover {
  background: var(--secondary-color-5) !important;
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .navik-header-container {
    padding: 0 40px;
  }
  .navik-header-container .burger-menu {
    display: none;
  }
  .navik-header-container .navik-menu {
    float: right;
    clear: inherit;
  }
  .navik-header-container .navik-menu ul {
    padding-bottom: 0;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .navik-header .burger-menu-container {
    width: 84px;
  }
  .navik-header.dark .navik-menu.show {
    background-color: var(--secondary-color-1);
  }
  .navik-header.dark .navik-menu ul {
    border-top: 1px solid rgba(95, 95, 95, 0.862745098);
  }
  .navik-header .logo {
    padding: 0 !important;
  }
  .navik-header .desktop-nav {
    display: none;
  }
  .navik-header .navik-header-container {
    display: flex;
    padding: 0 24px;
    align-items: center;
    justify-content: space-between;
  }
  .navik-header .navik-header-container .mobile-nav {
    display: block !important;
  }
  .navik-header .navik-menu {
    max-height: 0px;
    transition: 0.2s ease-in-out;
    width: 100vw;
    position: absolute;
    left: 0;
    top: 80px;
  }
  .navik-header .navik-menu.show {
    width: 100%;
    background-color: white;
    max-height: 60px;
  }
  .navik-header .navik-menu ul {
    opacity: 0;
    visibility: hidden;
    transition: 0.3s ease-in-out;
    height: 0;
    display: block;
    padding: 0;
    border-top: 1px solid rgba(190, 190, 190, 0.8352941176);
  }
  .navik-header .navik-menu ul > li.sign-in {
    display: none;
  }
  .navik-header .navik-menu ul.show {
    height: 50px;
    visibility: visible;
    opacity: 1;
  }
  .navik-header .navik-menu ul > li > a {
    line-height: normal !important;
    height: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/header.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,uBAAA;EACA,uBAAA;AADJ;AAEI;EACI,0CAAA;AAAR;AACQ;EACI,uBAAA;AACZ;AAEY;EACI,YAAA;AAAhB;AAGgB;EACI,uBAAA;AADpB;AAOI;EACI,eAAA;EACA,uBAAA;AALR;AAQY;EACI,YAAA;AANhB;AASQ;EACI,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,uCAAA;EACA,SAAA;AAPZ;AASQ;EACI,aAAA;AAPZ;AASQ;EACI,gBAAA;EACA,mBAAA;AAPZ;AAYwB;EACI,oBAAA;AAV5B;AAawB;EACI,kBAAA;AAX5B;AAiBY;EACI,0CAAA;AAfhB;AAiBgB;EACI,WAAA;AAfpB;AAiBoB;EACI,kBAAA;AAfxB;AAsBI;;;EAGI,YAAA;AApBR;AAuBI;EACI,wBAAA;EACA,mBAAA;AArBR;AAwBI;EACI,oBAAA;EACA,uCAAA;EACA,2BAAA;EACA,0BAAA;EACA,0CAAA;EACA,kBAAA;EACA,4BAAA;EACA,0BAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;AAtBR;AAuBQ;EAEI,yBAAA;AAtBZ;AAyBQ;EAEI,0CAAA;AAxBZ;AA6BQ;EACI,iBAAA;AA3BZ;AA+BI;EACI,+CAAA;AA7BR;AA+BQ;EACI,+CAAA;AA7BZ;;AC9EY;EDiHR;IACI,eAAA;EA/BN;EAiCM;IACI,aAAA;EA/BV;EAkCM;IACI,YAAA;IACA,cAAA;EAhCV;EAkCU;IACI,iBAAA;EAhCd;AACF;ACrGY;ED8IJ;IACI,WAAA;EAtCV;EA0Cc;IACI,0CAAA;EAxClB;EA0Cc;IACI,mDAAA;EAxClB;EA4CM;IACI,qBAAA;EA1CV;EA4CM;IACI,aAAA;EA1CV;EA4CM;IACI,aAAA;IACA,eAAA;IACA,mBAAA;IACA,8BAAA;EA1CV;EA2CU;IACI,yBAAA;EAzCd;EA4CM;IACI,eAAA;IACA,4BAAA;IACA,YAAA;IACA,kBAAA;IACA,OAAA;IACA,SAAA;EA1CV;EA2CU;IACI,WAAA;IACA,uBAAA;IACA,gBAAA;EAzCd;EA2CU;IACI,UAAA;IACA,kBAAA;IACA,4BAAA;IACA,SAAA;IACA,cAAA;IACA,UAAA;IACA,uDAAA;EAzCd;EA0Cc;IACI,aAAA;EAxClB;EA0Cc;IACI,YAAA;IACA,mBAAA;IACA,UAAA;EAxClB;EA4CkB;IACI,8BAAA;IACA,YAAA;EA1CtB;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.navik-header {\r\n    z-index: 999 !important;\r\n    background-color: wgite;\r\n    &.dark {\r\n        background-color: var(--secondary-color-1);\r\n        .navik-menu ul li>a {\r\n            color: white !important;\r\n        }\r\n        .navik-header-container {\r\n            .mobile-signin-link {\r\n                color: white;\r\n            }\r\n            .burger-menu {\r\n                >div {\r\n                    background-color: white;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    \r\n    .navik-header-container {\r\n        padding: 0 80px;\r\n        height: 80px !important;\r\n    \r\n        .logo {\r\n            img {\r\n                height: 20px;\r\n            }\r\n        }\r\n        .mobile-signin-link {\r\n            font-size: 10px;\r\n            color: var(--primary-color-1);\r\n            font-weight: 700;\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            margin: 0;\r\n        }\r\n        .mobile-nav {\r\n            display: none;\r\n        }\r\n        .burger-menu {\r\n            position: static;\r\n            align-items: center;\r\n    \r\n            &.menu-open {\r\n                >div {\r\n                    &.line-menu {\r\n                        &.last-line {\r\n                            align-self: flex-end;\r\n                        }\r\n    \r\n                        &.first-line {\r\n                            align-self: normal;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n    \r\n            >div {\r\n                background-color: var(--secondary-color-1);\r\n    \r\n                &.line-menu {\r\n                    height: 2px;\r\n    \r\n                    &.last-line {\r\n                        align-self: center;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    \r\n    .navik-menu,\r\n    .navik-menu>ul,\r\n    .navik-menu>ul li a {\r\n        height: 80px;\r\n    }\r\n    \r\n    .navik-menu>ul {\r\n        display: flex !important;\r\n        align-items: center;\r\n    }\r\n    \r\n    .navik-menu ul li>a {\r\n        text-transform: none;\r\n        font-family: 'Proxima Nova', sans-serif;\r\n        font-weight: 700 !important;\r\n        font-size: 14px !important;\r\n        color: var(--secondary-color-1) !important;\r\n        font-style: normal;\r\n        line-height: 80px !important;\r\n        padding: 0 15px !important;\r\n        transition: .2s ease-in;\r\n        height: 80px;\r\n        white-space: nowrap;\r\n        &:hover,\r\n        &.active {\r\n            color: #FAC91F !important;\r\n        }\r\n    \r\n        &.darkmode:hover,\r\n        &.darkmode.active {\r\n            color: var(--secondary-color-1) !important;\r\n        }\r\n    }\r\n    \r\n    .navik-menu>ul>li.sign-in {\r\n        >button {\r\n            margin-left: 20px;\r\n        }\r\n    }\r\n    \r\n    button.darkmode {\r\n        background: var(--secondary-color-1) !important;\r\n    \r\n        &:hover {\r\n            background: var(--secondary-color-5) !important;\r\n        }\r\n    }\r\n}\r\n\r\n@include media(tablet) {\r\n    .navik-header-container {\r\n        padding: 0 40px;\r\n\r\n        .burger-menu {\r\n            display: none;\r\n        }\r\n\r\n        .navik-menu {\r\n            float: right;\r\n            clear: inherit;\r\n\r\n            ul {\r\n                padding-bottom: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n}\r\n\r\n@include media(mobile) {\r\n    .navik-header {\r\n        .burger-menu-container {\r\n            width: 84px;\r\n        }\r\n        &.dark {\r\n            .navik-menu {\r\n                &.show {\r\n                    background-color: var(--secondary-color-1);\r\n                }\r\n                ul {\r\n                    border-top: 1px solid #5f5f5fdc;\r\n                }\r\n            }\r\n        }\r\n        .logo {\r\n            padding: 0 !important;\r\n        }\r\n        .desktop-nav {\r\n            display: none;\r\n        }\r\n        .navik-header-container {\r\n            display: flex;\r\n            padding: 0 24px;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            .mobile-nav  {\r\n                display: block !important;   \r\n            }\r\n        }\r\n        .navik-menu {\r\n            max-height: 0px;\r\n            transition: .2s ease-in-out;\r\n            width: 100vw;\r\n            position: absolute;\r\n            left: 0;\r\n            top: 80px;\r\n            &.show {\r\n                width: 100%;\r\n                background-color: white;\r\n                max-height: 60px;\r\n            } \r\n            ul {\r\n                opacity: 0;\r\n                visibility: hidden;\r\n                transition: .3s ease-in-out;\r\n                height: 0;\r\n                display: block;\r\n                padding: 0;\r\n                border-top: 1px solid #bebebed5;\r\n                > li.sign-in {\r\n                    display: none;\r\n                }\r\n                &.show {\r\n                    height: 50px;\r\n                    visibility: visible;\r\n                    opacity: 1;\r\n    \r\n                }\r\n                > li {\r\n                    > a {\r\n                        line-height: normal !important;\r\n                        height: auto;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
